var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"root"},[_c('img',{staticClass:"schedule-icon",attrs:{"src":require("@/assets/images/schedule/schedule.png")}}),_c('span',{staticClass:"empty-schedule"},[_vm._v(" 아직 약속이 없어요. "),_c('br'),_vm._v(" 상대방과 약속이 잡히면 이 곳에 표시돼요! ")])])
}]

export { render, staticRenderFns }